module.exports = __webpack_public_path__ + "static/media/acaritouch.4dd7496d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/aranha_roja_fresa/preventiva/acaritouch.png
// module id = 1539
// module chunks = 3